import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["list", "className"];
import React from 'react';
import List from './List';
import UnorderedList from './UnorderedList';

var UL = function UL(_ref) {
  var list = _ref.list,
      className = _ref.className,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/React.createElement(UnorderedList, {
    className: className
  }, /*#__PURE__*/React.createElement(List, Object.assign({
    list: list
  }, props)));
};

UL.defaultProps = {
  className: null
};
export default UL;